module.exports = __webpack_public_path__ + "static/lframe-commercial-vehicle-loan-12a5d74a2fca619c363524a74e421a65.png";